<template>
  <div id="filterForm">
    <v-form v-model="isFormValid" lazy-validation ref="form">
      <div v-if="!this.isWholeSales">
        <filter-row
          v-for="section in sections"
          @remove="removeSection(section.id)"
          :section="section"
          :key="section.id"
          :rules="[rules.required]"
        >
        </filter-row>
      </div>
      <div v-if="this.isWholeSales">
        <FilterRowWholeSales
          v-for="section in sections"
          @remove="removeSection(section.id)"
          :section="section"
          :key="section.id"
          :rules="[rules.required]"
        >
        </FilterRowWholeSales>
      </div>
      <v-btn color="green" outlined @click="addComponent()" small>
        <v-icon left> mdi-plus-circle-outline </v-icon>
        Add condition
      </v-btn>
      <v-row class="mt-1">
        <v-col cols="3">
          <v-btn
            @click="formatValues"
            :disabled="!isFormValid"
            tile
            color="success"
            :loading="loading"
            small
          >
            <v-icon left :color="loadingFailed ? 'error' : ''">{{
              loadingFailed ? "mdi-alert-circle" : "mdi-filter-variant"
            }}</v-icon>

            Filter products</v-btn
          >
        </v-col>
        <v-col cols="3">
          <v-btn @click="resetForm" tile color="accent" small>
            <v-icon left> mdi-refresh </v-icon>
            Reset form</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="loadingFailed">
        <v-col cols="5">
          <v-alert type="error" dense>
            {{ filterError }}
          </v-alert>
        </v-col>
      </v-row>
    </v-form>

    <v-snackbar v-model="snackbar" timeout="2000" top color="red">
      You must fill category field!

      <template v-slot:action="{ attrs }">
        <v-btn
          color="grey darken-4"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FilterRow from "@/components/molecules/FilterRow";
import FilterRowWholeSales from "@/components/molecules/FilterRowWholeSales.vue";
export default {
  name: "FilterForm",
  components: {
    FilterRow,
    FilterRowWholeSales,
  },
  props: { isWholeSalesProps : Boolean },
  data: function () {
    return {
      sections: [],
      rules: {
        required: (value) => !!value || "Field is required.",
      },
      isFormValid: true,
      count: 1,
      snackbar: false,
      loading: false,
      loadingFailed: false,
      filterError: "",
      isWholeSales : false
    };
  },
  mounted ()  {
    this.isWholeSales= this.isWholeSalesProps
  },
  methods: {
    removeSection: function (id) {
      var index = this.sections
        .map((x) => {
          return x.id;
        })
        .indexOf(id);
      if (this.sections.length > 0) this.sections.splice(index, 1);
    },

    addComponent() {
      this.count = this.count + 1;
      this.sections.push({
        id: this.count,
        property: "",
        condition: "",
        value: undefined,
      });
    },
    formatValues() {
      let validateCategory = true;
      console.log(JSON.stringify(this.sections))
      let categories = this.sections.filter((item) => {
        return item.property["name"] === "Category";
      });
      if (categories.length > 0) {
        validateCategory = categories.every((item) => item.value != undefined);
      }
      if (this.$refs.form.validate()) {
        if (validateCategory) {
          this.$emit("formatValues", this.sections);
          this.isFormValid = true;
        } else {
          this.snackbar = true;
        }
      } else {
        this.isFormValid = false;
      }
    },
    resetForm() {
      this.$refs.form.reset();
      this.sections = [];
      this.count = 1;
    },
    setLoading(value) {
      this.loading = value;
      this.loadingFailed = false;
    },
    setLoadingFailed(failed, error) {
      this.loading = false;
      this.filterError = error;
      this.loadingFailed = failed;
    },
  },
};
</script>
